import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";

const OurServices = () => {
  const services = [
  {
    id: 1,
    title: "Onion Powders",
    description:
      "Sourced from farm-fresh onions, our onion powders are processed with care to retain flavor, color, and aroma.",
    icon: "🧅",
  },
  {
    id: 2,
    title: "Garlic Powders",
    description:
      "We provide premium quality garlic powders that offer strong aroma and taste, ideal for culinary and food processing needs.",
    icon: "🧄",
  },
  {
    id: 3,
    title: "Dehydrated Vegetables",
    description:
      "Our dehydrated vegetables are preserved with minimal processing, ensuring high shelf-life and natural nutrition.",
    icon: "🥦",
  },
  {
    id: 4,
    title: "Spices",
    description:
      "Our collection of high-quality spices is carefully selected and processed to enhance the flavor of cuisines globally.",
    icon: "🌶️",
  },
  {
    id: 5,
    title: "Vegetable Powders",
    description:
      "We offer a range of pure and natural vegetable powders made from carefully dehydrated and ground produce.",
    icon: "🥕",
  },
];


  return (
    <Box sx={{ padding: 4, background: 'linear-gradient(135deg,rgb(0, 0, 0),rgb(0, 0, 0))', color: "#fff" }}>
      {/* Header Section */}
      <Typography
        variant="h6"
        align="center"
        gutterBottom
        sx={{ fontSize: "14px", textTransform: "uppercase", letterSpacing: 2 }}
      >
        Our Services
      </Typography>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{ fontWeight: "bold" }}
      >
        Global Trade Excellence in Onion powders, Garlic Powders, Dehydrated Vegetables & Spices
      </Typography>
      <Typography align="center">
        Unispeherexim  is committed to delivering high-quality products with seamless import and export services.
      </Typography>

      {/* Services Grid */}
      <Grid container spacing={4} sx={{ marginTop: 4 }}>
        {services.map((service) => (
          <Grid item xs={12} sm={6} md={6} key={service.id}>
            <Paper
              elevation={0}
              sx={{
                padding: 3,
                textAlign: "left",
                backgroundColor: "transparent",
                borderRadius: 2,
                margin: 5,
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                animation: "floating 4s ease-in-out infinite", // Add animation
                "&:hover": {
                  transform: "translateY(-10px)",
                  boxShadow: "0 10px 20px rgba(0, 0, 0, 0.1)",
                },
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  paddingBottom: "4px",
                  marginBottom: "8px",
                }}
              >
                <Typography
                  variant="h1"
                  sx={{
                    fontSize: "24px",
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                >
                  {service.id < 10 ? `0${service.id}` : service.id}
                </Typography>
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "2px",
                    backgroundColor: "#fff",
                  }}
                />
              </Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  marginBottom: 1,
                  color: "#fff",
                }}
              >
                {service.icon} {service.title}
              </Typography>
              <Typography
                sx={{
                  opacity: 0.8,
                  fontSize: "14px",
                  color: "#D4C9B6",
                }}
              >
                {service.description}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Add the floating animation */}
      <style jsx>{`
        @keyframes floating {
          0% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px); /* Move slightly up */
          }
          100% {
            transform: translateY(0);
          }
        }
      `}</style>
    </Box>
  );
};

export default OurServices;